export const getEmployeeName = (email: string): string => {
  const emp = employees.find((e) => e.value === email);
  return emp?.label || "";
};

// Labels must match the HRMS employee profile name exactly — attendance
// punches and leave requests store this name.
export const employees = [
  { label: "Tamanna Rajpal", value: "tamannar@manoshala.com" },
  { label: "Priyanka Duvvuri", value: "priyankad@manoshala.com" },
  { label: "Vineet Manchanda", value: "account@manoshala.com" },
  { label: "Utkarshani Raj", value: "experts@manoshala.com" },
  { label: "Suzzane Khan", value: "suzzanek@manoshala.com" },
  { label: "Ayush Singh", value: "ayushs@manoshala.com" },
  { label: "Sweta Kumari", value: "noreply@manoshala.com" },
  { label: "Manya Kaushik", value: "manyak@manoshala.com" },
  { label: "Navya Kukreti", value: "community@manoshala.com" },
  { label: "Sushmit Chakraborty", value: "sushmitc@manoshala.com" },
  { label: "Mahi Saxena", value: "mahis@manoshala.com" },
  { label: "Sharanya Menon", value: "wellness@manoshala.com" },
  { label: "Vasudha Ramani", value: "vasudhar@manoshala.com" },
  { label: "Kratika Agarwal", value: "ceooffice@manoshala.com" },
  { label: "Sahil Singh Rathore", value: "sahils@manoshala.com" },
  { label: "Sanjay Christy", value: "sanjayc@manoshala.com" },
  { label: "Hafsah Syed", value: "hafsahs@manoshala.com" },
  { label: "Navya Varrier", value: "navyav@manoshala.com" },
  { label: "Yasar Borkar", value: "yasarb@manoshala.com" },
];
